<template>
    <section class="streaks">
        <section id="streaks-banner">
            <div class="container">

                <div class="row row-2">
                    <div class="col-12 d-flex justify-content-between align-items-center">
                        <div>
                            <h2>Music Streak</h2>
                            <p>Your music on repeat</p>
                        </div>

                        <div class="profile">
                            <img src="@/assets/images/Ellipse 8.png" alt="">
                            <h4>54K Followers</h4>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        
        <!-- media section -->
        <section class="musics">
            <div class="container-large">
                <div class="row">
                    <div class="col-12">
                        <div v-if="loading" class="loader">Loading...</div>
                        <ul class="music-grid" v-else-if="mediaItems.length > 0">
                            <li v-for="media in mediaItems" :key="media.id" class="music-item">
                                <div class="music-item-wrap">
                                    <img :src="media.thumbnail" alt="" class="music-img">
                                    <h4 class="music-name">{{ media.title }}</h4>
                                </div>
                            </li>
                        </ul>
                        <p v-else class="no-data">No data found</p>
                    </div>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    name: 'StreakCategory',
    inject: ['api'],
    props: {
        msg: String
    },
    data() {
        return {
            mediaItems: [], // Store fetched media items
            loading: false // Track loading state
        };
    },
    async mounted() {
        this.loading = true; // Show loader
        try {
            const token = localStorage.getItem('rockstar_token'); // Retrieve user token
            const categoryId = this.$route.params.categorySlug; // Get category ID from route params
            const response = await axios.get(`${this.api.base_url}/media`, {
                params: { category_id: categoryId }, // Send category_id as a parameter
                headers: {
                    token: this.api.token,
                    'user-token': token
                }
            });
            this.mediaItems = response.data.data; // Assign API response to mediaItems
        } catch (error) {
            console.error('Error fetching media items:', error);
        } finally {
            this.loading = false; // Hide loader
        }
    }
};
</script>

<style scoped>
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
.music-description {
    font-size: 0.9rem;
    color: #666;
}
.no-data {
    text-align: center;
    font-size: 1.2rem;
    color: #999;
    margin-top: 20px;
}
.loader {
    text-align: center;
    font-size: 1.2rem;
    color: #666;
    margin-top: 20px;
}
</style>